import React, { Component } from 'react';
import { Layout } from 'antd';

export default class Main extends Component {

    render() {
        return (
            <Layout className={'layout-v vstretch ' + this.props.className || " "}>
                {this.props.children}
            </Layout>
        );
    }
}